import './xeroContactAddressSearchPopup.scss';

import { DropdownEditor, Popup, Radiobox } from '@approvalmax/ui';
import { ConnectedProps } from 'modules/react-redux';
import { TbSearchGreyIcon } from 'modules/sprites';
import React from 'react';
import bemFactory from 'react-bem-factory';
import { connect } from 'react-redux';

import { selectXeroDeliveryAddress } from '../../../actions';
import { XeroAddress } from '../../../data/xero/XeroAddress';
import { XeroContact } from '../../../data/xero/XeroContact';
import { getXeroAddressTypeText } from '../../../selectors/xero';
import ContactDataProvider from '../dataProviders/ContactDataProvider';
import { messages } from './XeroContactAddressSearchPopup.messages';

function mapStateToProps() {
    return {};
}

const mapDispatchToProps = {
    selectXeroDeliveryAddress,
};

interface OwnProps {
    className?: string;
}

interface OwnState {
    contact: XeroContact | null;
    selectedAddress: XeroAddress | null;
}

type Props = ConnectedProps<OwnProps, typeof mapStateToProps, typeof mapDispatchToProps>;

class XeroContactAddressSearchPopup extends React.Component<Props, OwnState> {
    public state: OwnState = {
        contact: null,
        selectedAddress: null,
    };

    public render() {
        const { className } = this.props;
        const bem = bemFactory.block('reqf-xero-contact-address-search-popup');
        const qa = bemFactory.qa('reqf-xero-contact-address-search-popup');

        return (
            <Popup.DefaultContent
                className={bem.add(className)()}
                qa={qa()}
                title={messages.popupTitle}
                buttons={
                    <Popup.DefaultContent.Button
                        qa={qa('done-button')}
                        disabled={!this.state.selectedAddress}
                        execute={this._onDone}
                        title={messages.doneButtonTitle}
                    >
                        {messages.doneButtonText}
                    </Popup.DefaultContent.Button>
                }
            >
                <div className={bem('content')}>
                    <div className={bem('search-block')}>
                        <TbSearchGreyIcon width={15} height={15} className={bem('search-icon')} />

                        <ContactDataProvider>
                            <DropdownEditor
                                qa={qa('search-dropdown')}
                                className={bem('search-dropdown')}
                                value={this.state.contact}
                                onChange={this._onContactChange}
                                placeholder={messages.contactDropdownPlaceholder}
                                theme='transparent'
                            />
                        </ContactDataProvider>
                    </div>

                    {this.state.contact ? (
                        <div className={bem('address-list-block')} data-qa={qa('address-list')}>
                            {this.state.contact.addresses &&
                                this.state.contact.addresses.map((a) => {
                                    return (
                                        <div
                                            key={a.id}
                                            data-qa={bem('address-list-item')}
                                            data-qa-id={a.id}
                                            data-qa-name={a.text}
                                            className={bem('address-list-item')}
                                            onClick={() => this.setState({ selectedAddress: a })}
                                        >
                                            <div className={bem('address-list-item-radio')}>
                                                <Radiobox
                                                    checked={Boolean(
                                                        this.state.selectedAddress &&
                                                            a.id === this.state.selectedAddress.id
                                                    )}
                                                />
                                            </div>

                                            <div className={bem('address-list-item-content')}>
                                                <div className={bem('address-list-item-type')}>
                                                    {getXeroAddressTypeText(a)}
                                                </div>

                                                <div className={bem('address-list-item-text')}>{a.text}</div>

                                                {a.attentionTo && (
                                                    <div className={bem('address-list-item-attention')}>
                                                        {a.attentionTo}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    ) : (
                        <div className={bem('empty-block')}>{messages.emptyListPlaceholder}</div>
                    )}
                </div>
            </Popup.DefaultContent>
        );
    }

    private _onContactChange = (contact: XeroContact) => {
        this.setState({
            contact,
            selectedAddress: (contact && contact.addresses && contact.addresses[0]) || null,
        });
    };

    private _onDone = () => {
        this.props.selectXeroDeliveryAddress(this.state.selectedAddress!, this.state.contact!);
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(XeroContactAddressSearchPopup);
